import React from "react";

import { useMarkForRegeneration } from "api/api-hooks/reports-hooks";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { Button } from "primereact/button";
import { confirmPopup } from "primereact/confirmpopup";
import { T } from "services/lang/LanguageService";
import { GeneratedDashboardReportResponse } from "../../../api/model/dashboard/GeneratedDashboardReportResponse";

const MarkForRegeneration = (props: { rowData: GeneratedDashboardReportResponse }) => {
  const { mutate: markForRegeneration, isPending: markedForRegenerationLoading } =
    useMarkForRegeneration({
      onSuccess: () => {
        easasAlert({
          summary: T("alert.report-table.report-marked-for-regeneration"),
          severity: "success",
          life: 3000,
        });
      },
      onFailure: () => {
        easasAlert({
          summary: T("alert.report-table.failed-to-mark-report-for-regeneration"),
          severity: "error",
          life: 3000,
        });
      },
    });

  const confirm = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    confirmPopup({
      target: event.currentTarget,
      message: T("confirm-popup.report-table.mark-for-regeneration"),
      icon: "pi pi-question-circle",
      accept: () => markForRegeneration({ genId: [props.rowData.id], lazy: false }),
    });
  };

  return (
    <div className="flex align-items-center">
      <Button
        icon="fa fa-retweet"
        className="p-button-rounded p-button-text p-button-sm"
        loading={markedForRegenerationLoading}
        onClick={confirm}
      />
    </div>
  );
};

export default MarkForRegeneration;
